// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"4059883f","144":"728c5171","212":"fd5c1117","297":"0076478a","474":"61535d7a","532":"81ffe7a0","717":"71a54099","793":"2c32e008","812":"e741975f"}[chunkId] + ".chunk.js";
};